import * as GridCell from '../../grid-cell'
import { onEdit } from '../actions'
import * as Constants from '../constants'
import * as Types from '../types'

export class ActiveCell extends GridCell.ActiveAndEditCell<Types.System> {
  constructor(props: any) {
    super(props, Constants.UPDATE_SYSTEM_INLINE, props.dataItem[Constants.ID] === '', null, onEdit)
  }
}



// WEBPACK FOOTER //
// ./src/pages/integrations/render/active_cell.tsx